import type { ActionTree, GetterTree, MutationTree } from 'vuex'
import { RootState } from '~/store'
import { $api } from '~/plugins/axios'

export const namespace = 'modules/Common'

export interface CommonState {
  totalOrders: number,
}

export const ActionType = {
  FETCH_SALES_STATISTICS: 'fetchSalesStatistics',
}
export const MutationType = {
  SET_TOTAL_ORDERS: 'setTotalOrders',
}

export const state = (): CommonState => ({
  totalOrders: 0,
})

export const getters: GetterTree<CommonState, RootState> = {}

export const actions: ActionTree<CommonState, RootState> = {
  async [ActionType.FETCH_SALES_STATISTICS] ({ commit }) {
    try {
      const {
        items
      } = await $api.PublicHandbookService.searchHandbooks({
        handbook_slug: 'order_counter',
        page: 1,
        per_page: 1,
      })

      if (!items?.length) {
        return
      }

      const { sales_completed_counter } = items[0]

      commit(MutationType.SET_TOTAL_ORDERS, sales_completed_counter ?? 0)
    } catch (error:any) {
      throw new Error(error)
    }
  },
}

export const mutations: MutationTree<CommonState> = {
  [MutationType.SET_TOTAL_ORDERS] (state, orders: number): void {
    state.totalOrders = orders
  },
}
